import { adminUserService } from '../services/adminUser';

export function handleResponse(response) {
    return response.json().then(data => {

        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                adminUserService.logout();

                window.location.reload(true);
            }
            const error = (data && data.error) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}


// WEBPACK FOOTER //
// ./src/helper/handleResponse.jsx